import * as e from "react";
const a = (t) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 18", ...t }, /* @__PURE__ */ e.createElement("path", { fill: "#1f2830", d: "M3.904 15.068 9.748 9.22a.286.286 0 0 0 0-.405L3.904 2.97a1.143 1.143 0 1 1 1.613-1.616l6.453 6.452a1.714 1.714 0 0 1 0 2.425l-6.453 6.453a1.142 1.142 0 1 1-1.613-1.616" }));
export {
  a as default
};
